import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';

var iconSizeVariants = {
    xxs: "tw-h-2",
    xs: "tw-h-3",
    sm: "tw-h-3.5",
    md: "tw-h-4",
    lg: "tw-h-5",
    xl: "tw-h-6",
    xxl: "tw-h-7",
    "3xl": "tw-h-8",
    "4xl": "tw-h-10",
    "5xl": "tw-h-12"
};
/**
 * An img-element icon. In general, prefer the Font Awesome icons. In the cases where we need an icon not provided by Font Awesome, this component can be used.
 */
var ImgIcon = forwardRef(function (_a, ref) {
    var addClassName = _a.addClassName, _b = _a.size, size = _b === void 0 ? "md" : _b, passThrough = __rest(_a, ["addClassName", "size"]);
    var classes = classNames("tw-inline-block tw-overflow-visible tw-align-middle", iconSizeVariants[size], addClassName);
    return React.createElement("img", __assign({}, passThrough, { className: classes, ref: ref }));
});
ImgIcon.displayName = "ImgIcon";

export { ImgIcon };
//# sourceMappingURL=ImgIcon.esm.js.map
